import styled from 'styled-components';
import { Colors } from '../../constants/Colors';

export const Container = styled.div`
  min-height: 100vh;
  background-color: ${Colors?.bgLight || '#f2f2f2'};
  padding: 20px;
  display: flex;
  justify-content: center;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 980px;
  background: ${Colors?.commons.white || '#fff'};
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
`;

export const Title = styled.h2`
  margin: 0 0 14px 0;
  color: ${Colors?.commons.black || '#111'};
  font-size: 18px;
  font-weight: 700;
`;

export const ToggleWrap = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ToggleButton = styled.button<{ $active?: boolean }>`
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid ${({ $active }) => ($active ? (Colors?.primary[100] || '#111') : (Colors?.commons.gray || '#ddd'))};
  background: ${({ $active }) => ($active ? (Colors?.primary[100] || '#111') : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : (Colors?.commons.black || '#111'))};
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;

  &:hover {
    opacity: 0.92;
  }
`;

export const Content = styled.div`
  margin-top: 16px;
`;
